import { StandardType } from '../../common/common.types';

export const compareNames = (
  { name: a }: StandardType,
  { name: b }: StandardType,
) => a.localeCompare(b);
